import { render, staticRenderFns } from "./CategoryCardFooter.vue?vue&type=template&id=791f0ea4&scoped=true"
import script from "./CategoryCardFooter.vue?vue&type=script&setup=true&lang=ts"
export * from "./CategoryCardFooter.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./CategoryCardFooter.vue?vue&type=style&index=0&id=791f0ea4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "791f0ea4",
  null
  
)

export default component.exports